import { render, staticRenderFns } from "./LabelHorizontal.vue?vue&type=template&id=d257965e&scoped=true&"
import script from "./LabelHorizontal.vue?vue&type=script&lang=js&"
export * from "./LabelHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./LabelHorizontal.vue?vue&type=style&index=0&id=d257965e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d257965e",
  null
  
)

export default component.exports